var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampingWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12489 16.7501H4.57091L10.7018 6.05189L8.77489 2.68806C8.46437 2.14975 8.64892 1.46129 9.18723 1.15077C9.72554 0.840241 10.414 1.02479 10.7245 1.5631L11.9996 3.79034L13.2747 1.5631C13.5853 1.02479 14.2737 0.840222 14.812 1.15077C15.3503 1.46131 15.5349 2.14975 15.2244 2.68806L13.2953 6.06295L19.4284 16.7501H19.8744C20.4955 16.7501 20.9993 17.254 20.9993 17.875C20.9993 18.4961 20.4955 19 19.8744 19H14.7521L12.7269 14.9498C12.5892 14.6751 12.3073 14.5008 11.9997 14.5008C11.6921 14.5008 11.4101 14.6751 11.2724 14.9498L9.24728 19H4.12496C3.50389 19 3 18.4961 3 17.875C3 17.254 3.50381 16.7501 4.12489 16.7501Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampingWhite);
export default __webpack_public_path__ + "static/media/camping-white.e29b6bcf71cc9512974fe5e19601687f.svg";
export { ForwardRef as ReactComponent };